module.exports = __webpack_public_path__ + "fj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/fj.svg
// module id = 799
// module chunks = 0